import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_biy9ek6rw1: FaireBrandEntity = {
  token: "b_biy9ek6rw1",
  type: "brand",
  name: "Mayu Water",
  avatarUrl:
    "https://cdn.faire.com/fastly/97a313b730da8b32d36cbfa2210b3c24890f5f537afcabc01d3695a8691c7f37.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/975c07a091804780ed008608e05dacc3e826ee3b68a199abb84a7c0cd1a72e97.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/97a313b730da8b32d36cbfa2210b3c24890f5f537afcabc01d3695a8691c7f37.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/975c07a091804780ed008608e05dacc3e826ee3b68a199abb84a7c0cd1a72e97.jpeg",
  location: "Cleveland, OK, USA",
  minimumOrderDollars: 139,
  rating: 5,
  reviewCount: 12,
  isTopShop: true,
  isInsider: true,
  description:
    "MAYU redefines hydration by returning water to its purest form. Inspired by the flow of natural springs, our products revive structure, replenish minerals, and elevate everyday water into living water. The MAYU Swirl restores water’s molucular structure for optimized hydration and MAYU Trace Mineral Drops replenishes the essential nutrients that purification strips away.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:20.335Z",
    importedBy: "entity-db-cli",
  },
};
